import { ApiService } from "./api.service";

export const LocationColumnSetting: any = {
  locationName: { label: "Location", visibility: true, order: 1 },
  latitude: { label: "Latitude", visibility: true, order: 2 },
  longitude: { label: "Longitude", visibility:true, order:3},
  name: { label: "Job Safety", visibility: true, order: 4 },
  criticalActivities:{ label: "Critical Activities", visibility: true, order: 5 },
  lifeSavingRules:{ label: "Life Saving Rules", visibility: true, order: 6 },
  status: { label: "Status", visibility: true, order: 7 } ,
  startDate: { label: "Start Date", visibility: true, order: 8 },
};

export class JobSafetyAnalysisWorksheetService {
    get() {
        return ApiService.get("ElectronicalPermittingPortal/GetStatusByLocations");
    }

    getDetailslist(longitude: string | number,latitude: string | number,asset:string,locationName: string) {
        const params = new URLSearchParams({
            longitude: String(longitude),
            latitude: String(latitude),
            asset: asset ?? "",
            location: locationName ?? "",
        });
        return ApiService.get(`ElectronicalPermittingPortal/GetFormDetailsByLocation?${params.toString()}`);
    }
    GetAllAssetsList()
    {
        return ApiService.get(`ElectronicalPermittingPortal/GetAllAssetsList`);
    }
    GetAllLocationList(asset:string)
    {
        const params = new URLSearchParams({ asset: asset ?? "" });
        return ApiService.get(`ElectronicalPermittingPortal/GetAllLocations?${params.toString()}`);
    }
}
